module.exports = __webpack_public_path__ + "static/media/dsa3.81bff294.jpg";